<template>
<div class="toast"  v-show="isShow">
<div>{{message}}</div>
</div>
</template>

<script>
export default {
props:{
},
data() {
  return {
    message:'',
    isShow:false,
    showType:"toast"
  }
},
methods: {
  show(msg = '默认显示', duration = 1000){
    this.isShow = true;
    this.message = msg

    setTimeout(()=>{
   this.isShow = false;
   this.message =''
    },duration)
  },
  error(msg){
    this.show(msg)
  },
  success(msg){
    this.show(msg)
  }
},
}
</script>

<style scoped>
.toast{
  min-width: 200px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  position: fixed;
  font-size: 25px;
  top: 30%;
  left: 50%;
  z-index: 1000;
  color: #ffffff;
  background: rgba(0, 0, 0, .7);
  padding: 10px;
  transform: translate(-50%,-50%)
}

</style>
